import axios, { type AxiosResponse } from 'axios'

import { sendError } from '@/core/error'
import { sanitize } from '@/core/utils/security'

export interface RequestOptions {
  method?: string
  headers?: { [key: string]: string }
  body?: { [key: string]: string }
}

export const fetchDefault = async <T = any>(
  resource: string,
  options?: RequestOptions,
): Promise<T | null> => {
  const sanitizedUrl = sanitize(resource)
  try {
    const request = axios.create({
      ...options,
      headers: {
        ...options?.headers,
        'Content-Type': 'application/json',
      },
    })

    const response: AxiosResponse<T> = await request({
      method: options?.method,
      url: sanitizedUrl,
    })

    if (response.status !== 200) Promise.reject(await response.data)
    return await response.data
  } catch (error) {
    console.log('ERROR catch', error)
    sendError({ error, context: { resource, options } })
    return null
  }
}
